module.exports = __webpack_public_path__ + "media/images/icon_home_yamori-08882777f7e05ca56a2a67250697cca0.svg";